import { Skeleton,Stack,Typography } from '@mui/material';
import { PrintTemplateType } from '../../../types/print-template/types';

export default function HeaderModalDetailPrint(
  { printTemplate,
    checkBrightness,
    isLoading
  }: {
    printTemplate?: PrintTemplateType | undefined,
    checkBrightness: Function,
    isLoading: boolean
  }) {

  return (
    isLoading
      ? < Skeleton variant="rounded" height={60} width={'100%'} />
      : <Stack direction='column' spacing={1} width='100%' justifyContent='flex-start' alignItems='center'>
        {printTemplate?.logo && (<img alt="Logo da empresa" src={printTemplate.logo} width={130} />)}
        <Typography textAlign='center' paddingTop={2} paddingBottom={2} width='100%' sx={{
          backgroundColor: printTemplate?.color,
          border: 'none',
          fontSize: `${printTemplate?.headerText?.size}px`,
          fontWeight: printTemplate?.headerText?.bold ? 600 : 500,
          fontStyle: printTemplate?.headerText?.italic ? 'italic' : 'normal',
          color: !printTemplate?.color?.length ? 'black' : (checkBrightness(printTemplate?.color) ? 'black' : 'white')
        }}>
          {printTemplate?.headerText?.text}
        </Typography>
      </Stack>
  );
}